module.exports = {
	"1": {
		"id": 1,
		"name": "quantity",
		"title": "Количество",
		"type": "number",
		"value": 1
	},
	"2": {
		"id": 2,
		"name": "length",
		"title": "Длина",
		"type": "number"
	},
	"3": {
		"id": 3,
		"name": "width",
		"title": "Ширина",
		"type": "number"
	},
	"4": {
		"id": 4,
		"name": "height",
		"title": "Высота",
		"type": "number"
	},
	"5": {
		"id": 5,
		"name": "volume",
		"title": "Объем",
		"type": "number"
	},
	"6": {
		"id": 6,
		"name": "weight",
		"title": "Вес",
		"type": "number"
	},
	"7": {
		"id": 7,
		"name": "unit_of_measurement",
		"title": "Ед. изм.",
		"type": "list",
		"values": [
			{
				"id": 1,
				"value": "см / кг",
				"stuff_attribute_id": 7,
				"is_default": 1
			},
			{
				"id": 2,
				"value": "м / т",
				"stuff_attribute_id": 7,
				"is_default": 0
			}
		]
	},
	"8": {
		"id": 8,
		"name": "comment",
		"title": "Описание",
		"type": "textarea"
	},
	"9": {
		"id": 9,
		"name": "disassembly",
		"title": "Разбирается",
		"type": "checkbox"
	},
	"10": {
		"id": 10,
		"name": "not_fit_elevator",
		"title": "Не помещается в лифт",
		"type": "checkbox"
	},
	"11": {
		"id": 11,
		"name": "photo",
		"title": "Фото",
		"type": "list",
		"values": [
			{
				"id": 19,
				"value": "Оригинал",
				"stuff_attribute_id": 11,
				"is_default": 0
			},
			{
				"id": 20,
				"value": "Для листинга",
				"stuff_attribute_id": 11,
				"is_default": 0
			}
		]
	},
	"12": {
		"id": 12,
		"name": "auto_brand",
		"title": "Марка",
		"type": "text"
	},
	"13": {
		"id": 13,
		"name": "auto_model",
		"title": "Модель",
		"type": "text"
	},
	"14": {
		"id": 14,
		"name": "year_of_manufacture",
		"title": "Год выпуска",
		"type": "number"
	},
	"15": {
		"id": 15,
		"name": "is_working",
		"title": "На ходу",
		"type": "checkbox"
	},
	"16": {
		"id": 16,
		"name": "wheels_are_spinning",
		"title": "Колеса крутятся",
		"type": "checkbox"
	},
	"17": {
		"id": 17,
		"name": "number_of_persons",
		"title": "Количество человек",
		"type": "number"
	},
	"18": {
		"id": 18,
		"name": "number_of_hours",
		"title": "Количество часов",
		"type": "number"
	},
	"19": {
		"id": 19,
		"name": "arm_length",
		"title": "Длина стрелы",
		"type": "number"
	},
	"20": {
		"id": 20,
		"name": "tow_bar_type",
		"title": "Вид фаркопа",
		"type": "list",
		"values": [
			{
				"id": 12,
				"value": "A",
				"stuff_attribute_id": 20,
				"is_default": 1
			},
			{
				"id": 13,
				"value": "B",
				"stuff_attribute_id": 20,
				"is_default": 0
			},
			{
				"id": 14,
				"value": "C",
				"stuff_attribute_id": 20,
				"is_default": 0
			},
			{
				"id": 15,
				"value": "F",
				"stuff_attribute_id": 20,
				"is_default": 0
			},
			{
				"id": 16,
				"value": "G",
				"stuff_attribute_id": 20,
				"is_default": 0
			},
			{
				"id": 17,
				"value": "H",
				"stuff_attribute_id": 20,
				"is_default": 0
			},
			{
				"id": 18,
				"value": "N",
				"stuff_attribute_id": 20,
				"is_default": 0
			}
		]
	},
	"21": {
		"id": 21,
		"name": "packing_methods",
		"title": "Способы упаковки",
		"type": "list",
		"values": [
			{
				"id": 3,
				"value": "Палеты",
				"stuff_attribute_id": 21,
				"is_default": 0
			},
			{
				"id": 4,
				"value": "Биг-Бег",
				"stuff_attribute_id": 21,
				"is_default": 0
			},
			{
				"id": 5,
				"value": "Навалом",
				"stuff_attribute_id": 21,
				"is_default": 0
			},
			{
				"id": 6,
				"value": "Листы",
				"stuff_attribute_id": 21,
				"is_default": 0
			},
			{
				"id": 7,
				"value": "Бочки",
				"stuff_attribute_id": 21,
				"is_default": 0
			},
			{
				"id": 8,
				"value": "Ящики",
				"stuff_attribute_id": 21,
				"is_default": 0
			},
			{
				"id": 9,
				"value": "Коробки",
				"stuff_attribute_id": 21,
				"is_default": 0
			},
			{
				"id": 10,
				"value": "Рулоны",
				"stuff_attribute_id": 21,
				"is_default": 0
			},
			{
				"id": 11,
				"value": "Насыпью",
				"stuff_attribute_id": 21,
				"is_default": 0
			},
			{
				"id": 21,
				"value": "Не выбран",
				"stuff_attribute_id": 21,
				"is_default": 1
			}
		]
	},
	"22": {
		"id": 22,
		"name": "with_trailer",
		"title": "На прицепе",
		"type": "checkbox"
	},
	"23": {
		"id": 23,
		"name": "name",
		"title": "Наименование",
		"type": "text"
	},
	"24": {
		"id": 24,
		"name": "packing_service",
		"title": "Вид упаковки",
		"type": "checkbox"
	}
};


//////////////////
// WEBPACK FOOTER
// ./configs/attributes.config.json
// module id = 1591
// module chunks = 0